import { z } from "zod";
import { AgencyIdSchema } from "../primitives/ids.js";
import { TraceContextSchema } from "./trace.js";
import { BatchAuditBatchIdSchema } from "./batch-audit.js";
/** batch-audit-job-payload.v1.0 — BullMQ worker job for agency batch URL audit. */
export const BatchAuditJobPayloadV1Schema = z
    .object({
    schemaVersion: z.literal("batch-audit-job-payload.v1.0"),
    jobKind: z.literal("PROCESS_BATCH_AUDIT"),
    batchId: BatchAuditBatchIdSchema,
    agencyId: AgencyIdSchema,
    itemIds: z.array(z.string().min(1)).min(1).max(50),
    trace: TraceContextSchema,
})
    .strict();
export const BATCH_AUDIT_QUEUE_NAME = "tier0-batch-audit";
export function batchAuditEnqueueJobId(batchId) {
    return `enr:batch-audit:${batchId}`;
}
//# sourceMappingURL=batch-audit-job-payload.js.map